(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duro-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('duro-product-carousel')) {
  customElements.define('duro-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.duro-launch__track');
      this.slides = [...this.querySelectorAll('.duro-launch__slide')];
      this.controls = this.querySelector('.duro-launch__carousel-controls');
      this.counter = this.querySelector('.duro-launch__carousel-count');
      if (this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.controls.hidden = false;
      this.index = 0;
      const update = () => {
        this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      };
      const go = (index) => {
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-direction]');
        if (button) go(this.index + Number(button.dataset.direction));
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(update, 120);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) go(index);
      }, options);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.scrollTimer);
    }
  });
}

if (!customElements.get('duro-featured-carousel')) {
  customElements.define('duro-featured-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.duro-launch__products');
      this.controls = this.querySelector('.duro-featured__controls');
      this.buttons = [...this.querySelectorAll('button[data-step]')];
      if (!this.track || !this.controls) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = max < 2;
        this.buttons[0].setAttribute('aria-disabled', String(position < 2));
        this.buttons[1].setAttribute('aria-disabled', String(position >= max - 2));
      };
      const move = (direction) => {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({left: direction * step * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-step]');
        if (button && button.getAttribute('aria-disabled') !== 'true') move(Number(button.dataset.step));
      }, options);
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, options);
      this.track.addEventListener('scroll', update, {...options, passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
